import React from 'react';

// components
import ConversationItem from 'eCoach/convoPrep/ConversationItem';
import ClickableListCard from 'eCoach/ClickableListCard';
import ConversationItemClicked from 'eCoach/convoPrep/ConversationItemClicked';
// import DocumentList from 'pageECoach/documentDisplay/DocumentList';
import ECoachResponse from 'eCoach/cardTemplates/ECoachResponse';
import Loader from 'eCoach/loaders/Loader';

// hooks
import { useEcoachItemsConsumer } from 'eCoach/hooks/useEcoachItemsConsumer';
import { StepOutput } from 'types/step';

interface Session {
  id: string;
  [key: string]: any;
}

// Create a wrapper component that adapts ConversationItem to the expected interface
const ConversationItemWrapper = ({ item }: { item: any }): JSX.Element => {
  // Ensure the item has the required properties for ConversationItem
  const conversationStep = {
    ...item,
    short_description: item.short_description || '',
  };

  return <ConversationItem item={conversationStep} />;
};

interface ConversationItemsCardProps {
  activeSession: Session;
  stepOutput: StepOutput;
}

export default function ConversationItemsCard({
  activeSession,
  stepOutput,
}: ConversationItemsCardProps): JSX.Element {
  const { items, selectedItem, selectItem } = useEcoachItemsConsumer(
    activeSession.id,
    stepOutput
  );

  return (
    <>
      <ECoachResponse status={items.status} loader={<Loader />}>
        <ClickableListCard
          isNumbered
          ItemDetailsComponent={ConversationItemClicked}
          items={items.data}
          ListItemComponent={ConversationItemWrapper}
          selectedItem={selectedItem}
          selectItem={selectItem}
        />
        {/* //FIXME */}
        {/* {stepOutput.suggestion_items.documents.length > 0 && (
          <DocumentList
            documentList={stepOutput.suggestion_items.documents}
            session={activeSession.id}
          />
        )} */}
      </ECoachResponse>
    </>
  );
}
